import { v4 as uuidv4 } from "uuid";
import { typesNodes } from "../../types/nodeTypes/typesNodes";
import { DEFAULT_POSITION_MAIN } from "./defaultPosition";

export const addNodeTitle = ({
  setNodes,
  setEdges,
  dataNode,
  type,
  nodesExist,
}) => {
  const id = uuidv4();

  const parentData = dataNode?.data?.parentData;
  const handleSelect = handleSourceSelect(type);

  if (!type) return;
  const newNode = [
    {
      id: `${parentData?.type}-${id}`,
      position:
        handleSelect === "top"
          ? { x: 163, y: 74 }
          : handleSelect === "bottom"
          ? { x: 162, y: 555 }
          : DEFAULT_POSITION_MAIN[nodesExist]?.[0],
      type,
      data: {
        parentData,
      },
    },
  ];
  const newEdge = [
    {
      id: `add-edge-${newNode[0].id}`,
      source: handleSelect === "right" ? "buttonAdd-1" : parentData?.id,
      target: newNode[0].id,
      sourceHandle: handleSelect,
      type: "smoothstep",
      animated: true,
      data: {
        parentData: {
          id: `${parentData?.type}-${id}`,
          edgeId: `add-edge-${parentData?.type}-${id}`,
          type,
          principalParentType: parentData?.principalParentType || type,
          position:
            handleSelect === "top"
              ? { x: 118, y: 191 }
              : handleSelect === "bottom"
              ? { x: 118, y: 619 }
              : DEFAULT_POSITION_MAIN[nodesExist]?.[0],
        },
      },
    },
  ];

  if (handleSelect === "right") {
    newNode.push({
      id: `buttonAdd-${type}`,
      position: DEFAULT_POSITION_MAIN[nodesExist]?.[1],
      type: typesButtons[type] || typesNodes.buttonAdd,
      data: {
        offsetXbutton:
          DEFAULT_POSITION_MAIN[nodesExist]?.[1].x -
          DEFAULT_POSITION_MAIN[nodesExist]?.[0].x,
        offsetYbutton:
          DEFAULT_POSITION_MAIN[nodesExist]?.[1].y -
          DEFAULT_POSITION_MAIN[nodesExist]?.[0].y,
        parentData: {
          id: `${parentData?.type}-${id}`,
          type,
          principalParentType: type,
          position: DEFAULT_POSITION_MAIN[nodesExist]?.[1],
        },
      },
    });

    newEdge.push({
      id: `buttonAdd-edge-${type}`,
      source: newNode[0].id,
      target: newNode[1].id,
      type: "smoothstep",
      animated: true,
    });
  }

  if (dataNode.type === typesNodes.buttonAdd) {
    setNodes((prev) => [
      ...prev.map((i) => {
        if (i.id === "buttonAdd-1") {
          return {
            ...i,
            type: typesNodes.addButton,
          };
        }
        return i;
      }),
      ...newNode,
    ]);
  } else {
    setNodes((prev) => [...prev, ...newNode]);
  }
  setEdges((prevEdge) => [...prevEdge, ...newEdge]);
};
const typesButtons = {
  [typesNodes.extension]: typesNodes.buttonAddExtension,
  [typesNodes.parameter]: typesNodes.buttonAddParams,
};

const handleSourceSelect = (type) => {
  switch (type) {
    case "defaultResponseIntentNode":
      return "bottom";
    case "descriptionIntentNode":
      return "top";
    default:
      return "right";
  }
};

export const addNode = ({
  setNodes,
  setEdges,
  dataNode,
  type,
  nodesExist,
  offsetX = 96,
  offsetY = 218,
  dataInfo,
}) => {
  if (!type) return;
  const id = uuidv4();
  const parentData = dataNode?.data?.parentData;
  const parentPosition = parentData?.position || { x: 0, y: 0 };
  const index = nodesExist || 0;
  const position = {
    x: parentPosition.x + offsetX,
    y:
      parentPosition.y +
      (index % 2 === 0
        ? offsetY * (index / 2)
        : -offsetY * Math.ceil(index / 2)),
  };
  const newNode = {
    id: `${parentData?.type}-${id}`,
    position,
    type,
    data: {
      parentData,
      dataInfo,
      offsetX,
      offsetY: position.y - parentPosition.y,
    },
  };

  const newEdge = {
    id: `add-edge-${newNode.id}`,
    source: dataNode.id,
    target: newNode.id,
    type: "smoothstep",
    animated: true,
    data: {
      parentData: {
        id: `${parentData?.type}-${id}`,
        edgeId: `add-edge-${parentData?.type}-${id}`,
        type,
        principalParentType: parentData?.principalParentType || type,
        position,
      },
    },
  };

  if (dataNode.type === "buttonAdd") {
    setNodes((prev) => [
      ...prev.map((i) => {
        if (i.id === dataNode.id) {
          return {
            ...i,
            type: "addButton",
          };
        }
        return i;
      }),
      newNode,
    ]);
  } else {
    setNodes((prev) => [...prev, newNode]);
  }
  setEdges((prevEdge) => [...prevEdge, newEdge]);
};

export const addNodeExtension = ({
  setNodes,
  setEdges,
  dataNode,
  type,
  nodesExist = 0,
  offsetX = 96,
  offsetY = 218,
  dataInfo,
}) => {
  if (!type) return;
  const id = uuidv4();
  const parentData = dataNode?.data?.parentData;
  const parentPosition = parentData?.position || { x: 0, y: 0 };
  const index = nodesExist;
  const position = {
    x: dataNode.xPos + offsetX,
    y:
      dataNode.yPos +
      (index
        ? index % 2 === 0
          ? offsetY * (index / 2)
          : -offsetY * Math.ceil(index / 2)
        : offsetY),
  };
  const newNode = [
    {
      id: `${parentData?.type}-${id}`,
      position,
      type,
      data: {
        parentData,
        dataInfo,
        offsetX,
        offsetY: position.y - parentPosition.y,
      },
    },
  ];

  let newEdge = [];

  if (type !== typesNodes.extensionConfig) {
    newEdge.push({
      id: `add-edge-${newNode[0].id}`,
      source: dataNode.id,
      target: newNode[0].id,
      type: "smoothstep",
      animated: true,
      data: {
        parentData: {
          id: `${parentData?.type}-${id}`,
          edgeId: `add-edge-${parentData?.type}-${id}`,
          type,
          principalParentType: parentData?.principalParentType || type,
          position,
        },
      },
    });
  }

  if (!dataInfo) {
    newNode.push({
      id: `${typesNodes.buttonAddExtension}-${type}`,
      position: { x: position.x + 975.5, y: position.y + 177.5 },
      type: typesNodes.buttonAddExtensions,
      data: {
        parentData: {
          id: newNode[0].id,
          type,
          principalParentType: type,
          position: DEFAULT_POSITION_MAIN[nodesExist]?.[0],
        },
        offsetXbutton: 975.5,
        offsetYbutton: 177.5,
      },
    });

    newEdge.push({
      id: `buttonAdd-edge-${type}`,
      source: newNode[0].id,
      target: newNode[1].id,
      type: "smoothstep",
      animated: true,
    });
  }
  if (type === typesNodes.extensionConfig) {
    setNodes((prev) => [
      ...prev.filter((i) => i.type !== typesNodes.buttonAddExtension),
      ...newNode,
    ]);
    setEdges((prevEdge) => [
      ...prevEdge.map((i) => {
        if (i.target === dataNode.id) {
          return {
            ...i,
            target: newNode[0].id,
          };
        }
        return i;
      }),
      ...newEdge,
    ]);
  } else {
    setNodes((prev) => [...prev, ...newNode]);
    setEdges((prevEdge) => [...prevEdge, ...newEdge]);
  }
};
export const addButtonExtension = ({ setNodes, setEdges, dataNode, type }) => {
  if (!type) return;
  const parentData = dataNode?.data?.parentData;
  const parentPosition = parentData?.position || { x: 0, y: 0 };
  const position = {
    x: parentPosition.x + dataNode.data.offsetX - 9,
    y: parentPosition.y + dataNode.data.offsetY + 178,
  };

  const newNode = {
    id: `${typesNodes.buttonAddExtension}-${type}`,
    position: position,
    type: typesNodes.buttonAddExtension,
    data: {
      parentData,
      offsetXbutton: dataNode.data.offsetX + 266,
      offsetYbutton: dataNode.data.offsetY + 193,
    },
  };

  setNodes((prev) => [...prev, newNode]);
  setEdges((prevEdge) => [
    ...prevEdge.map((i) => {
      if (i.target === dataNode.id) {
        return {
          ...i,
          target: newNode.id,
        };
      }
      return i;
    }),
  ]);
};
